import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import sidebarBgImage from 'assets/img/sidebar/sidebar-4.jpg';
import po from '../../assets/img/others/po.gif';
import { useHistory } from 'react-router-dom';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import {
  Nav,
  NavItem,
  NavLink as BSNavLink,
  Button,
  Collapse,
} from 'reactstrap';
import {
  MdAddShoppingCart,
  MdDashboard,
  MdShoppingCart,
  MdKeyboardArrowDown,
  MdSend,
} from 'react-icons/md';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import AddAlarmIcon from '@mui/icons-material/AddAlarm';
import BusinessIcon from '@mui/icons-material/Business'; // Example supplier-related icon

import TodayIcon from '@mui/icons-material/Today';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import AddHomeWorkIcon from '@mui/icons-material/AddHomeWork';
import AddTaskIcon from '@mui/icons-material/AddTask';
import ShareLocationIcon from '@mui/icons-material/ShareLocation';
import { RiShoppingCartFill } from 'react-icons/ri';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { FaUsersCog } from 'react-icons/fa';
import ReportIcon from '@mui/icons-material/Report';
import { RiExchangeDollarFill } from "react-icons/ri";
import InsertChartIcon from '@mui/icons-material/InsertChart';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import PaymentIcon from '@mui/icons-material/Payment';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import GavelIcon from '@mui/icons-material/Gavel';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { FaUserGraduate } from "react-icons/fa";
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import AirlineStopsIcon from '@mui/icons-material/AirlineStops';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import AdsClickIcon from '@mui/icons-material/AdsClick';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import BadgeIcon from '@mui/icons-material/Badge';
import iconsimage from '../../assets/img/others/tompgg.gif';
import bn from 'utils/bemnames';
import './Sidebar.css';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import axios from '../../axios';
import AssessmentIcon from '@mui/icons-material/Assessment';
import './MainLayout.css';
import StorefrontIcon from '@mui/icons-material/Storefront';
// import ReceiptIcon from '@mui/icons-material/Receipt';
import {
  Card,
  CardContent,
  Divider,
  Typography,
  Dialog,
  DialogContent,
  Slide,
  Button as Button2,
} from '@mui/material';
import AddCompanyLogo from '../../pages/AddCompanyLogo';
import { AiFillTags, AiFillSignal } from 'react-icons/ai';
import { FaBuilding, FaUserTie, FaCodeBranch, FaBox, FaLayerGroup, FaPercentage, FaBalanceScale } from "react-icons/fa";

const sidebarBackground = {
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundColor: 'black',
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Sidebar = () => {
  const history = useHistory();
  const [open, setOpen] = useState(false);

  const [userRoles, setUserRoles] = useState([]);
  const [brachAccessScreens, setbrachAccessScreens] = useState([]);
  const [levelUserAccessScreens, setlevelUserAccessScreens] = useState([]);
  const [activeScreens, setActiveScreens] = useState([]);
  const [finalScreensfrMapping, setFinalScreensfrMapping] = useState([]);
  const [activeUserModuleIds, setActiveUserModuleIds] = useState([]);

  const bem = bn.create('sidebar');

  const [isManagePoOpen, setisManagePoOpen] = useState(false);
  const [isUserControlsOpen, setisUserControlsOpen] = useState(false);
  const [isInventoryOpen, setisInventoryOpen] = useState(false);
  const [isReportsOpen, setisReportsOpen] = useState(false);
  const [isCompanyMstOpen, setisCompanyMstOpen] = useState(false);
  const [isCompanyTransOpen, setisCompanyTransOpen] = useState(false);

  // const [userAccess, setuserAccess] = useState([])


  const handleClick = name => () => {
    switch (name) {
      case 'manage_po':
        setisManagePoOpen(!isManagePoOpen);
        break;
      case 'user_controls':
        setisUserControlsOpen(!isUserControlsOpen);
        break;
      case 'inventory':
        setisInventoryOpen(!isInventoryOpen);
        break;
      case 'reports':
        setisReportsOpen(!isReportsOpen);
        break;
      case 'CompanyMaster':
        setisCompanyMstOpen(!isCompanyMstOpen);
        break;

      case 'CompanyTransactions':
        setisCompanyTransOpen(!isCompanyTransOpen);
        break;
      default:
        break;
    }
  };

  //company login
  const for_company_login =
    sessionStorage.getItem('WorkScenario') === 'company_login';

  //final user in scenario 1
  const basic_mis_alone =
    sessionStorage.getItem('WorkScenario') === 'mis_only_basic_scenario1';

  //final user in scenario 2
  const finaluser_pocreate_scenarios2 =
    sessionStorage.getItem('WorkScenario') === 'create_po_directly_scenario2' &&
    sessionStorage.getItem('UserRole') === 'final_level';

  //final user in scenario 3
  const finaluser_poapprove_scenarios3 =
    sessionStorage.getItem('WorkScenario') === 'po_with_approval_scenario3' &&
    sessionStorage.getItem('UserRole') === 'final_level';

  //final user in scenario 4
  const finaluser_poapprove_with_branch_scenarios3 =
    sessionStorage.getItem('WorkScenario') ===
    'po_with_approval_and_branches_scenario4' &&
    sessionStorage.getItem('UserRole') === 'final_level';

  //level 1 user in scenario 3
  const Level_one_user_as_po_create_scenario3 =
    sessionStorage.getItem('WorkScenario') === 'po_with_approval_scenario3' &&
    sessionStorage.getItem('UserRole') === 'level_one';

  //level 1 user in scenario 4
  const Level_one_user_as_po_approve_scenario4 =
    sessionStorage.getItem('WorkScenario') ===
    'po_with_approval_and_branches_scenario4' &&
    sessionStorage.getItem('UserRole') === 'level_one';

  //brnach user in scenario 4
  const branch_user_on_scenario4 =
    sessionStorage.getItem('WorkScenario') ===
    'po_with_approval_and_branches_scenario4' &&
    sessionStorage.getItem('UserRole') === 'branch_user';

  const inventroyAccess = sessionStorage.getItem('enable_inventory') === 'Y';

  // var userAccess = [{ User_id: 1, company: 'Y', Customer: 'Y' }];
  // Companydashboard

  var userAccess = JSON.parse(sessionStorage.getItem('userAccess')) || [];


  const CompanyDashboard = [
    {
      to: '/DashboardCompany',
      name: 'Dashboard',
      exact: false,
      Icon: SpaceDashboardIcon,
      ScreenCategory: 'CompanyDashboard',
      AccessGiven: 'yes',
      CategoryType: 'dashboard'
    },
  ];

  const SupplierControlAccess = [
    {
      to: '/SupplierAccess',
      name: 'Supplier Access Control',
      exact: false,
      Icon: BusinessIcon,
      ScreenCategory: 'SupplierAccess',
      AccessGiven: 'yes',
      CategoryType: 'SupplierAccess'
    },
    {
      to: '/Vendoraccess',
      name: 'Vendor Access Control',
      exact: false,
      Icon: StorefrontIcon,
      ScreenCategory: 'SupplierAccess',
      AccessGiven: 'yes',
      CategoryType: 'SupplierAccess'
    }
  ];

  // const updatedCompanyDashboard = CompanyDashboard.map(item => {
  //   // Convert the item name into a key that matches userAccess properties
  //   const key = item.CategoryType.toLowerCase().replace(/\s+/g, ''); // Removing spaces and making lowercase

  //   // Find the corresponding user access object
  //   const user = userAccess[0]; // Assuming only one user access object exists

  //   return {
  //     ...item,
  //     AccessGiven: user[key] === 'Y' ? 'yes' : 'no'  // Check access and update
  //   };
  // });

  console.log(userAccess, 'Getuserrole')

  // CompanyMaster

  // const CompanyMaster = [
  //   {
  //     to: "/CompanyMaster",
  //     name: "Company",
  //     exact: false,
  //     Icon: FaBuilding,
  //     ScreenCategory: 'CompanyMaster',
  //     AccessGiven: 'yes',
  //   },
  //   {
  //     to: "/CustomerMatser", // 🔹 Fixed typo (was "CustomerMatser")
  //     name: "Customer",
  //     exact: false,
  //     Icon: FaUserTie,
  //     ScreenCategory: 'CompanyMaster',
  //     AccessGiven: 'yes',
  //   },
  //   {
  //     to: "/CustomerBranchMst",
  //     name: "Customer Branch ",
  //     exact: false,
  //     Icon: FaCodeBranch,
  //     ScreenCategory: 'CompanyMaster',
  //     AccessGiven: 'yes',
  //   },
  //   {
  //     to: "/ProductCategoryMst",
  //     name: "Product Category ",
  //     exact: false,
  //     Icon: FaLayerGroup,
  //     ScreenCategory: 'CompanyMaster',
  //     AccessGiven: 'yes',
  //   },    

  //   {
  //     to: "/TaxMst",
  //     name: "Tax ",
  //     exact: false,
  //     Icon: FaPercentage,
  //     ScreenCategory: 'CompanyMaster',
  //     AccessGiven: 'yes',
  //   },
  //   {
  //     to: "/UOMMst",
  //     name: "UOM ",
  //     exact: false,
  //     Icon: FaBalanceScale,
  //     ScreenCategory: 'CompanyMaster',
  //     AccessGiven: 'yes',
  //   },
  //   {
  //     to: "/ProductMaster",
  //     name: "Product ",
  //     exact: false,
  //     Icon: FaBox,
  //     ScreenCategory: 'CompanyMaster',
  //     AccessGiven: 'yes',
  //   },
  // ];

  const CompanyMaster = [
    {
      to: "/CompanyMaster",
      name: "Company",
      exact: false,
      Icon: FaBuilding,
      ScreenCategory: 'CompanyMaster',
      AccessGiven: 'yes',
      CategoryType: 'company'
    },
    {
      to: "/CustomerMatser", // 🔹 Fixed typo (was "CustomerMatser")
      name: "Customer",
      exact: false,
      Icon: FaUserTie,
      ScreenCategory: 'CompanyMaster',
      AccessGiven: 'yes',
      CategoryType: 'customer'
    },
    {
      to: "/CustomerBranchMst",
      name: "Customer Branch ",
      exact: false,
      Icon: FaCodeBranch,
      ScreenCategory: 'CompanyMaster',
      AccessGiven: 'yes',
      CategoryType: 'customer_Branch'
    },
    {
      to: "/ProductCategoryMst",
      name: "Product Category ",
      exact: false,
      Icon: FaLayerGroup,
      ScreenCategory: 'CompanyMaster',
      AccessGiven: 'yes',
      CategoryType: 'product_Category'
    },

    {
      to: "/TaxMst",
      name: "Tax ",
      exact: false,
      Icon: FaPercentage,
      ScreenCategory: 'CompanyMaster',
      AccessGiven: 'yes',
      CategoryType: 'tax'
    },
    {
      to: "/UOMMst",
      name: "UOM ",
      exact: false,
      Icon: FaBalanceScale,
      ScreenCategory: 'CompanyMaster',
      AccessGiven: 'yes',
      CategoryType: 'uom'
    },
    {
      to: "/ProductMaster",
      name: "Product ",
      exact: false,
      Icon: FaBox,
      ScreenCategory: 'CompanyMaster',
      AccessGiven: 'yes',
      CategoryType: 'product'
    }, {
      to: "/DesignationMaster",
      name: "Designation ",
      exact: false,
      Icon: FaBox,
      ScreenCategory: 'CompanyMaster',
      AccessGiven: 'yes',
      CategoryType: 'Designation'
    }, {
      to: "/DepartmentMst",
      name: "Department",
      exact: false,
      Icon: FaBox,
      ScreenCategory: 'CompanyMaster',
      AccessGiven: 'yes',
      CategoryType: 'Department'
    }, {
      to: "/UserMaster",
      name: "User ",
      exact: false,
      Icon: FaBox,
      ScreenCategory: 'CompanyMaster',
      AccessGiven: 'yes',
      CategoryType: 'User_Register'
    },
    {
      to: "/BranchLog",
      name: "Branch Log ",
      exact: false,
      Icon: FaBox,
      ScreenCategory: 'CompanyMaster',
      AccessGiven: 'yes',
      CategoryType: 'Branch_log'
    },
    {
      to: "/CompanyLog",
      name: "Company Log ",
      exact: false,
      Icon: FaBox,
      ScreenCategory: 'CompanyMaster',
      AccessGiven: 'yes',
      CategoryType: 'Company_log'
    },
    {
      to: "/CompanyBranch",
      name: "Company Branch ",
      exact: false,
      Icon: FaBox,
      ScreenCategory: 'CompanyMaster',
      AccessGiven: 'yes',
      CategoryType: 'Company_Branch'
    },
  ];



  // const updatedCompanyMaster = CompanyMaster.map(item => {
  //   // Convert the item name into a key that matches userAccess properties
  //   const key = item.CategoryType.toLowerCase().replace(/\s+/g, ''); // Removing spaces and making lowercase

  //   // Find the corresponding user access object
  //   const user = userAccess[0]; // Assuming only one user access object exists

  //   return {
  //     ...item,
  //     AccessGiven: user[key] === 'Y' ? 'yes' : 'no'  // Check access and update
  //   };
  // });

  // console.log(updatedCompanyMaster);


  // for company only scenario
  const forCompanyLogin = [
    // {
    //   to: '/DashboardCompany',
    //   name: 'Dashboard',
    //   exact: false,
    //   Icon: SpaceDashboardIcon,
    //   ScreenCategory: 'reports',
    //   AccessGiven: 'yes',
    // },
    ...CompanyDashboard,
    ...CompanyMaster,
    ...SupplierControlAccess,
    // ...updatedCompanyDashboard,
    // ...updatedCompanyMaster,
    {
      to: "/Quotation",
      name: "Quotation",
      exact: false,
      Icon: ReceiptIcon,
      ScreenCategory: 'CompanyTransactions',
      AccessGiven: 'yes',
      CategoryType: 'quotation'
    },
    {
      to: '/PoAccept',
      name: 'Purchase Orders',
      exact: false,
      Icon: ShoppingCartCheckoutIcon,
      ScreenCategory: 'CompanyTransactions',
      AccessGiven: 'yes',
      CategoryType: 'po_Acceptance'
    },
    {
      to: '/PoStatusView',
      name: 'SO Status Update',
      exact: false,
      Icon: AiFillTags,
      ScreenCategory: 'CompanyTransactions',
      AccessGiven: 'yes',
      CategoryType: 'so_Status_Update'
    },

    // 📌 Master Screens
    // {
    //   to: "/CompanyMaster",
    //   name: "Company Master",
    //   exact: false,
    //   Icon: FaBuilding,
    // },
    // {
    //   to: "/CustomerMatser", // 🔹 Fixed typo (was "CustomerMatser")
    //   name: "Customer Master",
    //   exact: false,
    //   Icon: FaUserTie,
    // },
    // {
    //   to: "/CustomerBranchMst",
    //   name: "Customer Branch Master",
    //   exact: false,
    //   Icon: FaCodeBranch,
    // },
    // {
    //   to: "/ProductMaster",
    //   name: "Product Master",
    //   exact: false,
    //   Icon: FaBox,
    // },
    // {
    //   to: "/ProductCategoryMst",
    //   name: "Product Category Master",
    //   exact: false,
    //   Icon: FaLayerGroup,
    // },
    // {
    //   to: "/TaxMst",
    //   name: "Tax Master",
    //   exact: false,
    //   Icon: FaPercentage,
    // },
    // {
    //   to: "/UOMMst",
    //   name: "UOM Master",
    //   exact: false,
    //   Icon: FaBalanceScale,
    // },


    // {
    //   to: '/CompanyMaster',
    //   name: 'Company Master',
    //   exact: false,
    //   Icon: AiFillTags,
    // },
    // {
    //   to: '/CustomerMatser',
    //   name: 'Customer Master',
    //   exact: false,
    //   Icon: AiFillTags,
    // },
    // {
    //   to: '/CustomerBranchMst',
    //   name: 'Customer Branch Master',
    //   exact: false,
    //   Icon: AiFillTags,
    // },
    // {
    //   to: '/ProductMaster',
    //   name: 'Product Master',
    //   exact: false,
    //   Icon: AiFillTags,
    // },
    // {
    //   to: '/ProductCategoryMst',
    //   name: 'Product Category Master',
    //   exact: false,
    //   Icon: AiFillTags,
    // },
    // {
    //   to: '/TaxMst',
    //   name: 'Tax Master',
    //   exact: false,
    //   Icon: AiFillTags,
    // },
    // {
    //   to: '/UOMMst',
    //   name: 'UOM Master',
    //   exact: false,
    //   Icon: AiFillTags,
    // },
    // {
    //   to: '/salesorder',
    //   name: 'Sales Order ',
    //   exact: false,
    //   Icon: ShoppingBagIcon,
    //   ScreenCategory: 'reports',
    //   AccessGiven: 'yes',
    // },
    {
      to: '/CustomerAccessControls',
      name: 'Customer Access Controls ',
      exact: false,
      Icon: ManageAccountsIcon,
      ScreenCategory: 'Transactions',
      AccessGiven: 'yes',
      CategoryType: 'customer_Access_Control'
    },
    {
      to: '/AdsBanner',
      name: 'Ads Manager ',
      exact: false,
      Icon: AdsClickIcon,
      ScreenCategory: 'Transactions',
      AccessGiven: 'yes',
      CategoryType: 'Ads_Banner'
    },
     {
      to: '/POTrackingReports',
      // id: 27,
      name: 'PO Tracking Report',
      exact: false,
      Icon: ReceiptLongIcon,
      ScreenCategory: 'Transactions',
      AccessGiven: 'yes',
      CategoryType: 'Ads_Banner'
    },
    {
      to: '/SupplierAccess',
      name: 'Supplier Access Control ',
      exact: false,
      Icon: AdsClickIcon,
      ScreenCategory: 'SupplierControl',
      AccessGiven: 'yes',
      CategoryType: 'SupplierControl'
    },
    // {
    //   to: '/PaymentFollowupScreen',
    //   name: 'Add Payment Follow Up',
    //   exact: false,
    //   Icon: AddAlarmIcon,
    //   ScreenCategory: 'reports',
    //   AccessGiven: 'yes',
    // },
    // {
    //   to: '/PaymentFollowup',
    //   name: 'Payment Follow Up Reports ',
    //   exact: false,
    //   Icon: TodayIcon,
    //   ScreenCategory: 'reports',
    //   AccessGiven: 'yes',
    // },
  ];




  let updatedCompanylogin;
  if (userAccess.length != 0) {
    updatedCompanylogin = forCompanyLogin.map(item => {
      // Extract the key from CategoryType (ensure it exists)
      const key = item.CategoryType;

      if (!key) {
        return { ...item, AccessGiven: 'no' }; // If there's no CategoryType, deny access
      }

      // Find the corresponding user access object
      const user = userAccess[0]; // Assuming only one user access object exists

      // Normalize the key to match userAccess structure
      const formattedKey = Object.keys(user).find(uKey =>
        uKey.toLowerCase().replace(/_/g, '') === key.toLowerCase().replace(/_/g, '')
      );

      // Update AccessGiven based on the user's access rights
      return {
        ...item,
        AccessGiven: user[formattedKey] === 'Y' ? 'yes' : 'no'  // Check access and update
      };
    });
    console.log(updatedCompanylogin, 'for company login');
  }






  // const forMisOnly = [
  //   {
  //     to: '/outstanding',
  //     id: 13,
  //     name: 'OutStanding Bill Wise',
  //     exact: false,
  //     Icon: PriceCheckIcon,
  //     ScreenCategory: 'reports',
  //     AccessGiven: 'yes',
  //   },
  //   {
  //     to: '/StateMentOfAccount',
  //     name: 'Statement Of Accounts',
  //     id: 18,
  //     exact: false,
  //     Icon: RequestQuoteIcon,
  //     ScreenCategory: 'reports',
  //     AccessGiven: 'yes',
  //   },
  //   {
  //     to: '/SalesInvoiceReport',
  //     id: 19,
  //     name: 'Invoices Report',
  //     exact: false,
  //     Icon: ReceiptLongIcon,
  //     ScreenCategory: 'reports',
  //     AccessGiven: 'yes',
  //   },
  //   {
  //     to: '/Payment',
  //     id: 20,
  //     name: 'Payment Register',
  //     exact: false,
  //     Icon: ReceiptIcon,
  //     ScreenCategory: 'reports',
  //     AccessGiven: 'yes',
  //   },
  // ];

  const dashboard = [
    {
      to: '/DashboardCustomer',
      name: 'Dashboard',
      id: 1,
      exact: true,
      Icon: SpaceDashboardIcon,
      ScreenCategory: 'Dashboard',
      AccessGiven: 'yes',
    },
  ];

  // for mis only scenario
  const forMisOnlyUser = [
    ...dashboard,
    {
      to: '/outstanding',
      id: 13,
      name: 'OutStanding Bill Wise',
      exact: false,
      Icon: PriceCheckIcon,
      ScreenCategory: 'manage_po',
      AccessGiven: 'yes',
    },
    {
      to: '/StateMentOfAccount',
      name: 'Statement Of Accounts',
      id: 18,
      exact: false,
      Icon: RequestQuoteIcon,
      ScreenCategory: 'manage_po',
      AccessGiven: 'yes',
    },
    {
      to: '/SalesInvoiceReport',
      id: 19,
      name: 'Invoices',
      exact: false,
      Icon: ReceiptLongIcon,
      ScreenCategory: 'reports',
      AccessGiven: 'yes',
    },
    {
      to: '/Payment',
      id: 20,
      name: 'Payment Receipts',
      exact: false,
      Icon: ReceiptIcon,
      ScreenCategory: 'manage_po',
      AccessGiven: 'yes',
    },
  ];

  const basicReports = [
    // {
    //   to: '/potracking',
    //   name: 'Po Tracking',
    //   id: 14,
    //   exact: false,
    //   Icon: ShareLocationIcon,
    //   ScreenCategory: 'manage_po',
    //   AccessGiven: 'yes',
    // },
    // {
    //   to: '/Monthwiseorder',
    //   name: 'Month Wise Order Status',
    //   id: 10,
    //   exact: false,
    //   Icon: CalendarMonthIcon,
    //   ScreenCategory: 'reports',
    //   AccessGiven: 'yes',
    // },
  ];

  const managePO = [
    // {
    //   to: '/viewpo',
    //   name: 'Manage PO',
    //   id: 3,
    //   exact: true,
    //   Icon: PlaylistAddCheckIcon,
    //   ScreenCategory: 'manage_po',
    //   AccessGiven: 'yes',
    // },
    {
      to: '/viewindent',
      name: 'Manage Indent',
      id: 27,
      exact: true,
      Icon: PlaylistAddCheckIcon,
      ScreenCategory: 'manage_po',
      AccessGiven: 'yes',
    },
    {
      to: '/POTrackingReports',
      id: 27,
      name: 'PO Tracking Report',
      exact: false,
      Icon: ReceiptLongIcon,
      ScreenCategory: 'manage_po',
      AccessGiven: 'yes',
    },
  ];

  const UserControlScreens = [
    {
      to: '/CustomerUserReg',
      name: 'User Registration',
      exact: false,
      id: 5,
      Icon: PersonAddAlt1Icon,
      ScreenCategory: 'user_controls',
      AccessGiven: 'yes',
    },
    {
      to: '/UserRole',
      name: 'User Rights',
      exact: false,
      id: 17,
      Icon: AdminPanelSettingsIcon,
      ScreenCategory: 'user_controls',
      AccessGiven: 'yes',
    },
  ];

  const InventoryScreens = [
    {
      to: '/Department',
      id: 6,
      name: 'Department',
      exact: false,
      Icon: AddHomeWorkIcon,
      ScreenCategory: 'inventory',
      AccessGiven: 'yes',
    },
    {
      to: '/MaterialIssueEntry',
      id: 8,
      name: 'Material Issue',
      exact: false,
      Icon: AddTaskIcon,
      ScreenCategory: 'inventory',
      AccessGiven: 'yes',
    },
    {
      to: '/ViewMaterialReceipt',
      id: 7,
      name: 'Material Receipt',
      exact: false,
      Icon: ReceiptIcon,
      ScreenCategory: 'inventory',
      AccessGiven: 'yes',
    },
    {
      to: '/Stock',
      id: 12,
      name: 'Stock Report',
      exact: false,
      Icon: AddShoppingCartIcon,
      ScreenCategory: 'reports',
      AccessGiven: 'yes',
    },
    {
      to: '/MaterialReceiptReport',
      id: 15,
      name: 'Material Receipt Report',
      exact: false,
      Icon: ReceiptIcon,
      ScreenCategory: 'reports',
      AccessGiven: 'yes',
    },
    {
      to: '/MaterialIssue',
      id: 11,
      name: 'Material Issue Report',
      exact: false,
      Icon: ReceiptLongIcon,
      ScreenCategory: 'reports',
      AccessGiven: 'yes',
    },
    {
      to: '/POTrackingReports',
      id: 10,
      name: 'PO Tracking Report',
      exact: false,
      Icon: ReceiptLongIcon,
      ScreenCategory: 'reports',
      AccessGiven: 'yes',
    },

  ];

  const masterScreens = [
    // Client Requirement
    // {
    //   to: '/TermsAndCondition',
    //   id: 16,
    //   name: 'Terms And Condition',
    //   exact: false,
    //   Icon: GavelIcon,
    //   ScreenCategory: 'manage_po',
    //   AccessGiven: 'yes',
    // },
  ];

  // for final user with only create po on own
  const forFinalUserWithPOCreate = [
    ...dashboard,
    {
      to: '/viewpo',
      name: 'Manage PO',
      id: 3,
      exact: true,
      Icon: PlaylistAddCheckIcon,
      ScreenCategory: 'manage_po',
      AccessGiven: 'yes',
    },
    ...masterScreens,
    ...basicReports,
    // ...forMisOnly,
    ...(inventroyAccess ? InventoryScreens : []),
  ];

  // for final user with  approve and beow level 1
  const forFinalUserinScenario3 = [
    ...dashboard,
    {
      to: '/viewpo',
      name: 'Manage PO',
      id: 3,
      exact: true,
      Icon: PlaylistAddCheckIcon,
      ScreenCategory: 'manage_po',
      AccessGiven: 'yes',
    },
    ...masterScreens,
    ...UserControlScreens,
    ...basicReports,
    // ...forMisOnly,
    ...(inventroyAccess && sessionStorage.getItem('UserRole') === 'final_level'
      ? InventoryScreens
      : []),
  ];

  // for final user with  approve and beow level 1 and branch
  const forFinalUserinScenario3withBranch = [
    ...dashboard,
    {
      to: '/viewpo',
      name: 'Manage PO',
      id: 3,
      exact: true,
      Icon: PlaylistAddCheckIcon,
      ScreenCategory: 'manage_po',
      AccessGiven: 'yes',
    },
    // {
    //   to: '/Approval',
    //   id: 4,
    //   name: 'Po Approval',
    //   exact: false,
    //   Icon: ReceiptLongIcon,
    //   ScreenCategory: 'manage_po',
    //   AccessGiven: 'yes',
    // },
    ...masterScreens,
    ...UserControlScreens,
    // ...forMisOnly,
    ...basicReports,
    ...(inventroyAccess && sessionStorage.getItem('UserRole') === 'final_level'
      ? InventoryScreens
      : []),
  ];

  // for level one user with  po craeate
  const forLevel1onScenario3 = [
    ...dashboard,
    ...masterScreens,
    ...managePO,
    ...(inventroyAccess ? InventoryScreens : []),
    ...basicReports,
    // ...forMisOnly,
  ];

  // for level one user with  po approve
  const forLevel1onScenario4 = [
    ...dashboard,
    ...masterScreens,
    ...managePO,
    {
      to: '/Approval',
      id: 4,
      name: 'Po Approval',
      exact: false,
      Icon: ReceiptLongIcon,
      ScreenCategory: 'manage_po',
      AccessGiven: 'yes',
    },
    ...(inventroyAccess ? InventoryScreens : []),
    ...basicReports,
    // ...forMisOnly,
    ...UserControlScreens,
  ];

  // for brnach user
  const forBranchUser = [
    ...dashboard,
    ...masterScreens,
    ...managePO,
    ...(inventroyAccess ? InventoryScreens : []),
    ...basicReports,
    // ...forMisOnly,
    ...UserControlScreens,
  ];

  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  const GetUserRoles = async () => {
    console.log('inga varudha');
    const token = sessionStorage.getItem('authtoken');
    try {
      const response = await axios.instance.get(
        `/GetUserRights/${sessionStorage.getItem('Userid')}`,
        {
          headers: { Authorization: token, 'Content-Type': 'application/json' },
        },
      );
      setUserRoles(response.data);
      console.log('user role api data', response.data);
      const activeIds = response.data
        .filter(item => item.Enable === 'Y')
        .map(item => item.UserModuleId);
      setActiveUserModuleIds(activeIds);
      console.log('user role active ids', activeIds);
      filterScreens(activeIds);
    } catch (error) {
      console.error('There was an error fetching the user roles!', error);
    }
  };

  // const Getuserrole = async () => {
  //   // setOpenLoader(true);        
  //   let tokent = sessionStorage.getItem('authtoken');
  //   const role = await axios.instance
  //     .get(`/GetOneSupplierDetails/${sessionStorage.getItem('Userid')}`, {
  //       headers: { Authorization: tokent, 'Content-Type': 'application/json' },
  //     })
  //     .then(res => {
  //       console.log(res.data)
  //       setuserAccess(res.data)
  //       // setOpenLoader(false);
  //     });
  // };


  const filterScreens = useCallback(
    activeIds => {
      let screenData = Level_one_user_as_po_create_scenario3
        ? forLevel1onScenario3
        : Level_one_user_as_po_approve_scenario4
          ? forLevel1onScenario4
          : branch_user_on_scenario4
            ? forBranchUser
            : [];
      console.log('activeIds on filter', activeIds);
      console.log('screen data passed on filter', screenData);
      const filtered = screenData.filter(screen =>
        activeIds.includes(screen.id.toString()),
      );
      setActiveScreens(filtered);
      console.log('filtered access screens for the user', filtered);
      if (Level_one_user_as_po_create_scenario3) {
        setlevelUserAccessScreens(filtered);
        finalizeScreens2(filtered);
        console.log('assigned on: ', 'Level_one_user_as_po_create_scenario3');
      } else if (Level_one_user_as_po_approve_scenario4) {
        setlevelUserAccessScreens(filtered);
        finalizeScreens2(filtered);
        console.log('assigned on: Level_one_user_as_po_approve_scenario4');
      } else {
        if (branch_user_on_scenario4) {
          setbrachAccessScreens(filtered);
          finalizeScreens2(filtered);
          console.log(filtered, 'filtered')
          console.log('assigned on: branch_user_on_scenario4');
        }
      }
    },
    [levelUserAccessScreens],
  );

  const finalizeScreens2 = useCallback(
    data => {
      if (Level_one_user_as_po_create_scenario3) {
        console.log(
          'Condition matched: Level_one_user_as_po_create_scenario3',
          data,
        );
      } else if (Level_one_user_as_po_approve_scenario4) {
        console.log(
          'Condition matched: Level_one_user_as_po_approve_scenario4',
          data,
        );
      } else if (branch_user_on_scenario4) {
        console.log('Condition matched: branch_user_on_scenario4', data);
      } else {
        console.log('No condition matched, using default', data);
      }
      setFinalScreensfrMapping(data);
    },
    [
      Level_one_user_as_po_create_scenario3,
      Level_one_user_as_po_approve_scenario4,
      branch_user_on_scenario4,
    ],
  );

  const finalizeScreens = useCallback(() => {
    let finalscreens = [];

    if (basic_mis_alone) {
      finalscreens = forMisOnlyUser;
      console.log('Condition matched: basic_mis_alone');
    } else if (for_company_login) {
      // finalscreens = forCompanyLogin;
      finalscreens = userAccess.legth != 0 ? updatedCompanylogin : forCompanyLogin;
      console.log('Condition matched: for_company_login');
    } else if (finaluser_pocreate_scenarios2) {
      finalscreens = forFinalUserWithPOCreate;
      console.log('Condition matched: finaluser_pocreate_scenarios2');
    } else if (finaluser_poapprove_scenarios3) {
      finalscreens = forFinalUserinScenario3;
      console.log('Condition matched: finaluser_poapprove_scenarios3');
    } else if (finaluser_poapprove_with_branch_scenarios3) {
      finalscreens = forFinalUserinScenario3withBranch;
      console.log(
        'Condition matched: finaluser_poapprove_with_branch_scenarios3',
      );
    } else {
      finalscreens = [];
      console.log('No condition matched, using default');
    }
    setFinalScreensfrMapping(finalscreens);
  }, [levelUserAccessScreens, brachAccessScreens, finalScreensfrMapping]);




  // useEffect to fetch user roles and filter screens
  useEffect(() => {
    // Getuserrole();
    console.log(
      Level_one_user_as_po_approve_scenario4,
      'Level_one_user_as_po_approve_scenario4',
    );
    if (
      Level_one_user_as_po_create_scenario3 ||
      Level_one_user_as_po_approve_scenario4 ||
      branch_user_on_scenario4
    ) {
      GetUserRoles();
      console.log('varudhu');
    } else {
      finalizeScreens();
      console.log('varala');
    }
  }, []);

  return (
    <aside className={bem.b()} data-image={sidebarBgImage}>
      <div className={bem.e('background')} style={sidebarBackground} />
      <div
        //this condition defines the height of sidebar based on if ad is there or not
        className={basic_mis_alone ? bem.e('content') : bem.e('content2')}
      >
        <Nav vertical>
          <AddCompanyLogo />
          {for_company_login || basic_mis_alone ? (
            <>
              {/* {finalScreensfrMapping.map(
                ({ to, name, exact, Icon, ScreenCategory }, index) => (
                  <NavItem key={index} className={bem.e('nav-item')}>
                    <BSNavLink
                      id={`navItem-${name}-${index}`}
                      className="text-uppercase"
                      tag={NavLink}
                      to={to}
                      activeClassName="active"
                      exact={exact}
                    >
                      <Icon
                        fontSize="large"
                        color="inherit"
                        className={bem.e('nav-item-icon')}
                      />
                      <span className="">{name}</span>
                    </BSNavLink>
                  </NavItem>
                ),
              )} */}


              {/* company Dashboard */}
              {finalScreensfrMapping.map(
                ({ to, name, exact, Icon, ScreenCategory, AccessGiven }, index) =>
                  AccessGiven === 'yes' && ScreenCategory === 'CompanyDashboard' && (
                    <NavItem key={index} className={bem.e('nav-item')}>
                      <BSNavLink
                        id={`navItem-${name}-${index}`}
                        className="text-uppercase"
                        tag={NavLink}
                        to={to}
                        activeClassName="active"
                        exact={exact}
                      >
                        <Icon
                          fontSize="large"
                          color="inherit"
                          className={bem.e('nav-item-icon')}
                        />
                        <span className="">{name}</span>
                      </BSNavLink>
                    </NavItem>
                  ),
              )}

              {/* Supplier Access */}
              {sessionStorage.getItem('AdminUser1') == 'Y' &&
                finalScreensfrMapping.map(
                  ({ to, name, exact, Icon, ScreenCategory, AccessGiven }, index) =>
                    ScreenCategory === 'SupplierAccess' && (
                      <NavItem key={index} className={bem.e('nav-item')}>
                        <BSNavLink
                          id={`navItem-${name}-${index}`}
                          className="text-uppercase"
                          tag={NavLink}
                          to={to}
                          activeClassName="active"
                          exact={exact}
                        >
                          <Icon
                            fontSize="large"
                            color="inherit"
                            className={bem.e('nav-item-icon')}
                          />
                          <span className="">{name}</span>
                        </BSNavLink>
                      </NavItem>
                    ),
                )}
              {/* Master */}
              {sessionStorage.getItem('master') == 'Y' &&
                finalScreensfrMapping.some(
                  screen => screen.ScreenCategory === 'CompanyMaster',
                ) && (
                  <>
                    <NavItem
                      className={bem.e('nav-item')}
                      onClick={handleClick('manage_po')}
                    >
                      <BSNavLink className={bem.e('nav-item-collapse')}>
                        <div className="d-flex justify-content-center align-items-center gap-2">
                          <FaUserGraduate className={bem.e("nav-item-icon")} />
                          <span className="">Master</span>
                        </div>
                        <MdKeyboardArrowDown
                          className={bem.e('nav-item-icon')}
                          style={{
                            padding: 0,
                            transform: isManagePoOpen
                              ? 'rotate(0deg)'
                              : 'rotate(-90deg)',
                            transitionDuration: '0.3s',
                            transitionProperty: 'transform',
                          }}
                        />
                      </BSNavLink>
                    </NavItem>
                    <Collapse isOpen={isManagePoOpen} className="pl-4">
                      {finalScreensfrMapping.map(
                        ({ to, name, exact, Icon, ScreenCategory, AccessGiven }, index) =>
                          AccessGiven === 'yes' && ScreenCategory === 'CompanyMaster' && (
                            <NavItem key={index} className={bem.e('nav-item')}>
                              <BSNavLink
                                id={`navItem-${name}-${index}`}
                                className="text-uppercase"
                                tag={NavLink}
                                to={to}
                                activeClassName="active"
                                exact={exact}
                              >
                                <Icon className={bem.e('nav-item-icon')} />
                                <span className="">{name}</span>
                              </BSNavLink>
                            </NavItem>
                          ),
                      )}
                    </Collapse>
                  </>
                )
              }
              {/* Company Transactions */}
              {sessionStorage.getItem('transaction') == 'Y' &&
                finalScreensfrMapping.some(
                  screen => screen.ScreenCategory === 'CompanyTransactions',
                ) && (
                  <>
                    <NavItem
                      className={bem.e('nav-item')}
                      onClick={handleClick('CompanyTransactions')}
                    >
                      <BSNavLink className={bem.e('nav-item-collapse')}>
                        <div className="d-flex justify-content-center align-items-center gap-2">
                          <RiExchangeDollarFill className={bem.e("nav-item-icon")} />
                          <span className="">Transactions</span>
                        </div>
                        <MdKeyboardArrowDown
                          className={bem.e('nav-item-icon')}
                          style={{
                            padding: 0,
                            transform: isCompanyTransOpen
                              ? 'rotate(0deg)'
                              : 'rotate(-90deg)',
                            transitionDuration: '0.3s',
                            transitionProperty: 'transform',
                          }}
                        />
                      </BSNavLink>
                    </NavItem>
                    <Collapse isOpen={isCompanyTransOpen} className="pl-4">
                      {finalScreensfrMapping.map(
                        ({ to, name, exact, Icon, ScreenCategory, AccessGiven }, index) =>
                          AccessGiven === 'yes' && ScreenCategory === 'CompanyTransactions' && (
                            <NavItem key={index} className={bem.e('nav-item')}>
                              <BSNavLink
                                id={`navItem-${name}-${index}`}
                                className="text-uppercase"
                                tag={NavLink}
                                to={to}
                                activeClassName="active"
                                exact={exact}
                              >
                                <Icon className={bem.e('nav-item-icon')} />
                                <span className="">{name}</span>
                              </BSNavLink>
                            </NavItem>
                          ),
                      )}
                    </Collapse>
                  </>
                )}
              {/* transactions */}
              {finalScreensfrMapping.map(
                ({ to, name, exact, Icon, ScreenCategory, AccessGiven }, index) =>
                  AccessGiven === 'yes' && ScreenCategory === 'Transactions' && (
                    <NavItem key={index} className={bem.e('nav-item')}>
                      <BSNavLink
                        id={`navItem-${name}-${index}`}
                        className="text-uppercase"
                        tag={NavLink}
                        to={to}
                        activeClassName="active"
                        exact={exact}
                      >
                        <Icon
                          fontSize="large"
                          color="inherit"
                          className={bem.e('nav-item-icon')}
                        />
                        <span className="">{name}</span>
                      </BSNavLink>
                    </NavItem>
                  ),
              )
              }

            </>
          ) : (
            <>
              {/* Dashboard */}
              {finalScreensfrMapping.map(
                ({ to, name, exact, Icon, ScreenCategory }, index) =>
                  ScreenCategory === 'Dashboard' && (
                    <NavItem key={index} className={bem.e('nav-item')}>
                      <BSNavLink
                        id={`navItem-${name}-${index}`}
                        className="text-uppercase"
                        tag={NavLink}
                        to={to}
                        activeClassName="active"
                        exact={exact}
                      >
                        <Icon
                          fontSize="large"
                          color="inherit"
                          className={bem.e('nav-item-icon')}
                        />
                        <span className="">{name}</span>
                      </BSNavLink>
                    </NavItem>
                  ),
              )}
              {/* Purchase Orders */}
              {finalScreensfrMapping.some(
                screen => screen.ScreenCategory === 'manage_po',
              ) && (
                  <>
                    <NavItem
                      className={bem.e('nav-item')}
                      onClick={handleClick('manage_po')}
                    >
                      <BSNavLink className={bem.e('nav-item-collapse')}>
                        <div className="d-flex justify-content-center align-items-center gap-2">
                          <RiShoppingCartFill
                            className={bem.e('nav-item-icon')}
                          />
                          <span className="">Purchase Orders</span>
                        </div>
                        <MdKeyboardArrowDown
                          className={bem.e('nav-item-icon')}
                          style={{
                            padding: 0,
                            transform: isManagePoOpen
                              ? 'rotate(0deg)'
                              : 'rotate(-90deg)',
                            transitionDuration: '0.3s',
                            transitionProperty: 'transform',
                          }}
                        />
                      </BSNavLink>
                    </NavItem>
                    <Collapse isOpen={isManagePoOpen} className="pl-4">
                      {finalScreensfrMapping.map(
                        ({ to, name, exact, Icon, ScreenCategory }, index) =>
                          ScreenCategory === 'manage_po' && (
                            <NavItem key={index} className={bem.e('nav-item')}>
                              <BSNavLink
                                id={`navItem-${name}-${index}`}
                                className="text-uppercase"
                                tag={NavLink}
                                to={to}
                                activeClassName="active"
                                exact={exact}
                              >
                                <Icon className={bem.e('nav-item-icon')} />
                                <span className="">{name}</span>
                              </BSNavLink>
                            </NavItem>
                          ),
                      )}
                    </Collapse>
                  </>
                )}
              {/* User Controls */}
              {finalScreensfrMapping.some(
                screen => screen.ScreenCategory === 'user_controls',
              ) && (
                  <>
                    <NavItem
                      className={bem.e('nav-item')}
                      onClick={handleClick('user_controls')}
                    >
                      <BSNavLink className={bem.e('nav-item-collapse')}>
                        <div className="d-flex justify-content-center align-items-center gap-2">
                          <FaUsersCog className={bem.e('nav-item-icon')} />
                          <span className="">User Controls</span>
                        </div>
                        <MdKeyboardArrowDown
                          className={bem.e('nav-item-icon')}
                          style={{
                            padding: 0,
                            transform: isUserControlsOpen
                              ? 'rotate(0deg)'
                              : 'rotate(-90deg)',
                            transitionDuration: '0.3s',
                            transitionProperty: 'transform',
                          }}
                        />
                      </BSNavLink>
                    </NavItem>
                    <Collapse isOpen={isUserControlsOpen} className="pl-4">
                      {finalScreensfrMapping.map(
                        ({ to, name, exact, Icon, ScreenCategory }, index) =>
                          ScreenCategory === 'user_controls' && (
                            <NavItem key={index} className={bem.e('nav-item')}>
                              <BSNavLink
                                id={`navItem-${name}-${index}`}
                                className="text-uppercase"
                                tag={NavLink}
                                to={to}
                                activeClassName="active"
                                exact={exact}
                              >
                                <Icon className={bem.e('nav-item-icon')} />
                                <span className="">{name}</span>
                              </BSNavLink>
                            </NavItem>
                          ),
                      )}
                    </Collapse>
                  </>
                )}
              {/* Inventory Screens */}
              {finalScreensfrMapping.some(
                screen => screen.ScreenCategory === 'inventory',
              ) && (
                  <>
                    <NavItem
                      className={bem.e('nav-item')}
                      onClick={handleClick('inventory')}
                    >
                      <BSNavLink className={bem.e('nav-item-collapse')}>
                        <div className="d-flex justify-content-center align-items-center gap-2">
                          <AddBusinessIcon
                            fontSize="large"
                            color="inherit"
                            className={bem.e('nav-item-icon')}
                          />
                          <span className="">Inventory</span>
                        </div>
                        <MdKeyboardArrowDown
                          className={bem.e('nav-item-icon')}
                          style={{
                            padding: 0,
                            transform: isInventoryOpen
                              ? 'rotate(0deg)'
                              : 'rotate(-90deg)',
                            transitionDuration: '0.3s',
                            transitionProperty: 'transform',
                          }}
                        />
                      </BSNavLink>
                    </NavItem>
                    <Collapse isOpen={isInventoryOpen} className="pl-4">
                      {finalScreensfrMapping.map(
                        ({ to, name, exact, Icon, ScreenCategory }, index) =>
                          ScreenCategory === 'inventory' && (
                            <NavItem key={index} className={bem.e('nav-item')}>
                              <BSNavLink
                                id={`navItem-${name}-${index}`}
                                className="text-uppercase"
                                tag={NavLink}
                                to={to}
                                activeClassName="active"
                                exact={exact}
                              >
                                <Icon className={bem.e('nav-item-icon')} />
                                <span className="">{name}</span>
                              </BSNavLink>
                            </NavItem>
                          ),
                      )}
                    </Collapse>
                  </>
                )}

              {/* Reports */}
              {finalScreensfrMapping.some(
                screen => screen.ScreenCategory === 'reports',
              ) && (
                  <>
                    <NavItem
                      className={bem.e('nav-item')}
                      onClick={handleClick('reports')}
                    >
                      <BSNavLink className={bem.e('nav-item-collapse')}>
                        <div className="d-flex justify-content-center align-items-center gap-2">
                          <InsertChartIcon
                            fontSize="large"
                            color="inherit"
                            className={bem.e('nav-item-icon')}
                          />
                          <span className="">Reports</span>
                        </div>
                        <MdKeyboardArrowDown
                          className={bem.e('nav-item-icon')}
                          style={{
                            padding: 0,
                            transform: isReportsOpen
                              ? 'rotate(0deg)'
                              : 'rotate(-90deg)',
                            transitionDuration: '0.3s',
                            transitionProperty: 'transform',
                          }}
                        />
                      </BSNavLink>
                    </NavItem>
                    <Collapse isOpen={isReportsOpen} className="pl-4">
                      {finalScreensfrMapping.map(
                        ({ to, name, exact, Icon, ScreenCategory }, index) =>
                          ScreenCategory === 'reports' && (
                            <NavItem key={index} className={bem.e('nav-item')}>
                              <BSNavLink
                                id={`navItem-${name}-${index}`}
                                className="text-uppercase"
                                tag={NavLink}
                                to={to}
                                activeClassName="active"
                                exact={exact}
                              >
                                <Icon className={bem.e('nav-item-icon')} />
                                <span className="">{name}</span>
                              </BSNavLink>
                            </NavItem>
                          ),
                      )}
                    </Collapse>
                  </>
                )}
            </>
          )}
        </Nav>
      </div>

      {sessionStorage.getItem('enable_mis') === 'Y' &&
        sessionStorage.getItem('enable_po') === 'N' &&
        sessionStorage.getItem('enable_approval') === 'N' &&
        sessionStorage.getItem('enable_branch') === 'N' ? (
        <div className="stcky-footer-sidebar p-2">
          <Card
            className="cardstyle"
            style={{ boxShadow: '0px -36px 26px -6px rgb(4 0 0 / 38%)' }}
          >
            <CardContent>
              <img
                alt="text ad"
                className=""
                style={{
                  width: '70px',
                  height: '70px',
                  objectFit: 'contain',
                }}
                src={iconsimage}
              />
              <Typography
                variant="h6"
                component="div"
                color="white"
                sx={{ my: 2 }}
                className="text-style22"
              >
                Create{' '}
                <span style={{ color: '#295BA7', fontWeight: 'bolder' }}>
                  Purchase Orders
                </span>{' '}
                with a Single <span style={{ color: 'yellow' }}>Click</span>
              </Typography>
              <button className="flash-button2 mt-2" onClick={handleOpen}>
                Try It Now!
              </button>
            </CardContent>
            <Divider className=" mt-1" />
            <button
              className="button_footer"
              onClick={() => {
                history.push(
                  sessionStorage.getItem('CustomerLogin') === 'YES'
                    ? '/DashboardCustomer'
                    : '/DashboardCompany',
                );
              }}
            >
              T O M P G
            </button>
            <Typography variant="caption" color="white" fontSize={'small'}>
              Powered by{' '}
              <a
                href="https://asktek.net/"
                target="_blank"
                style={{ color: 'white', textDecoration: 'none' }}
              >
                ASK Technology
              </a>
            </Typography>
          </Card>
        </div>
      ) : (
        <div className="stcky-footer-sidebar p-2">
          <Card
            className="cardstyle d-flex flex-column justify-content-center align-items-center gap-2 pt-3"
            style={{ boxShadow: '0px -36px 26px -6px rgb(4 0 0 / 38%)' }}
          >
            <button
              className="button_footer"
              onClick={() => {
                history.push(
                  sessionStorage.getItem('CustomerLogin') === 'YES'
                    ? '/DashboardCustomer'
                    : '/DashboardCompany',
                );
              }}
            >
              T O M P G
            </button>
            <Typography variant="caption" color="white" fontSize={'small'}>
              Powered by{' '}
              <a
                href="https://asktek.net/"
                target="_blank"
                style={{ color: 'white', textDecoration: 'none' }}
              >
                ASK Technology
              </a>
            </Typography>
          </Card>
        </div>
      )}

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={'md'}
        TransitionComponent={Transition}
      >
        <DialogContent>
          <div className="row bg-white" style={{ minHeight: '400px' }}>
            <div className="col-lg-7">
              <div
                className="d-flex justify-content-center align-items-center gap-2"
                style={{ height: '100%' }}
              >
                <img
                  src={po}
                  alt="steps"
                  style={{
                    objectFit: 'contain',
                    maxHeight: '400px',
                    maxWidth: '100%',
                  }}
                />
              </div>
            </div>
            <div className="col-lg-5 d-flex justify-content-center align-items-center">
              <div className="d-flex flex-column justify-content-center align-items-center bg-white">
                <h1
                  className="text-gradient-title3 text-center"
                  style={{ fontFamily: 'oswald', color: '#7A81EB' }}
                >
                  Speed Up Your Operations
                </h1>
                <h2
                  className="text-gradient-title3 text-center"
                  style={{ fontFamily: 'oswald', color: '#68B984' }}
                >
                  Generate Your Purchase Order in Seconds!
                </h2>
                <Button2
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={() => {
                    history.push('/podemo');
                    handleClose();
                  }}
                  endIcon={<ArrowRightAltIcon />}
                >
                  Click to Proceed
                </Button2>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </aside>
  );
};

export default Sidebar;
